import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, resolveLocale, type Locale } from '@/i18n';
import { configDb } from '@/persistence/config-db';

/**
 * Language picker. Persists the choice to Dexie (`preferences` table)
 * so reloads keep the user's selection. Default detection lives in
 * `i18n/index.ts` and falls back to TR.
 */
export function LanguageSwitcher(): JSX.Element {
  const { t, i18n } = useTranslation();

  const onChange = (locale: Locale): void => {
    void i18n.changeLanguage(locale);
    void configDb.preferences.put({ key: 'locale', value: locale });
  };

  return (
    <select
      id="lang-select"
      value={resolveLocale(i18n.language)}
      onChange={(e) => onChange(e.target.value as Locale)}
      aria-label={t('language.label')}
      className="w-full text-xs rounded-md px-2.5 py-1.5"
      style={{
        background: 'var(--color-bg)',
        color: 'var(--color-fg)',
        border: '1px solid var(--color-border)',
      }}
    >
      {SUPPORTED_LOCALES.map((loc) => (
        <option key={loc} value={loc}>
          {t(`language.${loc}`)}
        </option>
      ))}
    </select>
  );
}
